import React from "react";
import ReactDOM from "react-dom";

import lodash from "lodash";
import { ToastContainer, toast } from "react-toastify";
import { Sidebar } from "primereact/sidebar";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";

import "react-toastify/dist/ReactToastify.css";

import "../mapa.css";

import getBrowserGeolocation from "../../util/geolocation";

import EmpreendimentoService from "../../services/empreendimentosServiceGeo";

import Loader from "../Loader";
import Ferramentas from "../Ferramentas/Ferramentas";
import FormFilters from "./FormFilters";
import Legenda from "./Legenda";
import LegendaUsers from "./LegendaUsers";
import MapWithADrawingManager from "./MapWithADrawingManager";
import SlidingPaneEmpreendimento from "./SlidingPanelEmpreendimento";
import ShapesAttributesEditor from '../ShapesAttributesEditor/ShapesAttributesEditor';
import ImportarExcelModal from "./ImportarExcelModal";
import KmlService from "../../services/KmlService";
import html2canvas from 'html2canvas';

import MapCapture from '../MapCapture/MapCapture';
import MapaService from "../../services/MapaService";
import EmpreendimentosServices from "../../services/empreendimentosServices";
import StoreModal from "./StoreModal";
import ListModal from "./ListModal";
import ModalSalvarProjeto from "../Projeto/ModalSalvarProjeto";
class DefaultMap extends React.Component {

    initialState = {
        raio: 3000,
        zoom: 15,
        selectedIcon: undefined,
        isSlideOpen: false,
        showMarkers: true,
        showBuildings: true,
        isDrawing: false,
        showLegenda: false,
        show_modal_map_screen_capture: false,
        showStoreModal: false,
        showListModal: false,
        canvas: null,
        selectedOverlay: null,
        loadingMetadata: false,

        buildings: [],
        users: [],

        user_type: [],
        ageOptions: [],
        age: [],
        genre: [],
        marital_status: [],
        children: [],

        minIncome: 0,
        maxIncome: 0,
        property_of_interest: [],
        typology_of_interest: [],
        bedrooms: [],
        incorporators: [],
        city: [],
        status: ["Comercialização"],
        uniqueProperties: [],

        overlays: [],
        manualCircles: [],
        polygons: [],
        circles: [],
        markers: [],
        pontos: [],

        left_side_bar_visible: true,
        buscaEmpreendimentossDefaultOptions: [],
        projetos: [],

        radiusChanging: '',
        showTooltip: false,
        show_modal_change_shape_attributes: false,
        current_shape_editing: null,

        showModalImportarExcel: false,
        importLoading: false,
        showModalWork: false,
        projeto: null,
        project_name: '',
        project_share_users: [],
        errors_projeto: {},
        loadingSaveProject: false,
        hide_search_box: false,
        mapScreenCaptureData: "",
        mapScreenCaptureDataForPDF: ""
    };
    state = { ...this.initialState, currentPosition: { lat: -25.442021, lng: -49.280201 } };

    componentDidMount = async () => {
        window.circles = [];
        window.markers = [];
        window.refs = [];
        let currentPosition = await getBrowserGeolocation();

        this.setState({ currentPosition: currentPosition, });

        const { data } = await axios.get('/geo-referenciamento/get-age-filters');

        this.setState({ ageOptions: data })

        document.getElementById("minimizeSidebar")?.click();
    };

    resetForm = () => { this.setState(this.initialState); };

    clearDefaultEmpreendimentos = () => { this.setState({ buscaEmpreendimentossDefaultOptions: [] }) }

    getUsers = async (circleUsers, polygonUsers) => {
        this.setState({ users: [] });

        const { selectedIcon } = this.state;

        const latAndLng = selectedIcon
            ? `${selectedIcon.position.lat},${selectedIcon.position.lng}`
            : undefined;

        const params = {
            city: this.state.city.map((city) => city.label),

            incorporators: this.state.incorporators,
            property_of_interest: this.state.property_of_interest,
            user_type: this.state.user_type,
            age: this.state.age,
            genre: this.state.genre,
            marital_status: this.state.marital_status,
            children: this.state.children,

            minIncome: this.state.minIncome,
            maxIncome: this.state.maxIncome,
            location: latAndLng,
            circle: circleUsers,
            polygon: polygonUsers,
        };

        try {
            const response = await axios.get("/geo-referenciamento/list", { params });

            return response.data;
        } catch (error) {
            console.error(error);
            return [];
        }
    };

    resetMarkers = (event) => {
        const { name } = event;

        this.setState((prevState) => ({
            [name]: prevState[name].map((item) => ({
                ...item,
                customMarker: undefined,
            })),
        }));
    };

    replaceMarkersUser = () => {
        this.setState((prevState) => ({
            users: prevState.users.map((user) => ({
                ...user,
                customMarker:
                    (user.genre === "masculino" || user.genre === "Masculino" || user.genre === "M")
                        ? "/img/markers/masc_blue.png"
                        : (user.genre === "feminino" || user.genre === "Feminino" || user.genre === "F") ? "/img/markers/fem_pink.png" : "/img/markers/others.png",
            })),
        }));
    };

    handleArrayChanged = async ({ name, value }) => {
        if (!value?.length) {
            this.setState({ [name]: [] });
            return;
        }

        this.setState({ [name]: value.map(({ value }) => value), });
    };

    handleChanged = ({ name, value }) => {
        this.setState({
            [name]: value ?? null,
        });
    };

    handleCityChanged = async ({ value }) => {

        if (!Array.isArray(value) || value.length === 0) {
            this.setState({ city: [] });
            return
        }

        const lastValue = value.at(-1)?.value;

        if (!lastValue) return value;

        const [state, city] = lastValue.split("-").map((v) => v.trim());

        try {
            const address = `${city}, ${state}, Brasil`;
            const geocoder = new window.google.maps.Geocoder();
            geocoder.geocode({ address }, (results, status) => {
                if (status === 'OK' && results[0]) {
                    window.googleMap.panTo(results[0].geometry.location);
                }
            });
        } catch (error) {
            console.error("Erro ao centralizar cidade:", error);
        } finally {
            this.setState({ city: value }, this.reloadBuildings);
        }
    };

    handleBedroomsChanged = (value) => {
        this.setState((prevState) => {
            const bedrooms = prevState.bedrooms.includes(value)
                ? prevState.bedrooms.filter((v) => v !== value)
                : [...prevState.bedrooms, value];

            return { bedrooms };
        });
    };


    searchBuildings = async (query) => {
        if (!query || query.length <= 1) return;

        const data = await EmpreendimentosServices.searchBuildings(query, this.state.city, this.state.incorporators);

        this.setState({ buscaEmpreendimentossDefaultOptions: data, });

        return data;
    };

    getColor = () => { return MapaService.getColor(this.state.overlays.length) };

    removeDuplicates = (buildings) => lodash.uniqBy(buildings, "_id");

    removeUsersDuplicates = (users) => lodash.uniqBy(users, "id");

    removeDuplicatesPropertyOfInterest = () => {
        const uniqueProperties = lodash
            .uniqBy(this.state.users, "property_of_interest")
            .map(({ property_of_interest }) => property_of_interest);

        this.setState({ uniqueProperties });
    };

    thereAreDrawnShapes = () => {
        const { polygons, manualCircles, circles } = this.state;
        return polygons.length > 0 || manualCircles.length > 0 || circles.length > 0;
    };

    reloadBuildings = async () => {
        try {
            if (window.innerWidth < 700) { $("#btn-filter").click(); }

            this.setState({ loading: true, buildings: [], users: [], loadingMetadata: true });

            const hasDrawnShapes = this.thereAreDrawnShapes();
            const hasCityFilter = this.state.city.length > 0;
            const hasOverlays = this.state.overlays.length > 0;
            const hasPropertyFilter = this.state.property_of_interest.length > 0;

            if (!hasDrawnShapes && !hasOverlays && !hasCityFilter && !hasPropertyFilter) {
                alert("Desenhe uma área no Mapa ou digite uma Cidade na caixa de busca do mapa");
                this.setState({ loading: false });
                return;
            }

            if (!hasDrawnShapes) {
                await this.reloadBuildingsInCity();
                this.setState({ loading: false });
                return;
            }

            const [buildingsInCircles, buildingsInPolygons,] = await Promise.all([
                this.reloadBuildingsOnCircle(),
                this.reloadBuildingsFromPolygons(),
            ]);

            const buildings = [...buildingsInCircles.buildings, ...buildingsInPolygons.buildings,];

            const users = [...buildingsInCircles.users, ...buildingsInPolygons.users,];

            const buildingsWithoutDuplicate = this.removeDuplicates(buildings);

            const usersWithoutDuplicate = this.removeUsersDuplicates(users);

            this.setState({
                buildings: buildingsWithoutDuplicate,
                users: usersWithoutDuplicate,
                loading: false,
                selectedIcon: undefined,
                showLegenda: true,
                loadingMetadata: false
            });

            if (usersWithoutDuplicate.length) {
                this.replaceMarkersUser();
                this.removeDuplicatesPropertyOfInterest();
            }

            if (buildingsWithoutDuplicate.length || usersWithoutDuplicate.length) {
                this.openPane();
            } else {
                toast.warn("Nenhum resultado com os parâmetros fornecidos");
            }
        } catch (error) {
            console.error("Erro ao recarregar empreendimentos:", error);
            this.setState({ loading: false });
        }
    };

    openPane = () => { this.setState({ isSlideOpen: true, }) };

    reloadBuildingsOnCircle = async () => {
        const { manualCircles, overlays } = this.state;

        if (!manualCircles.length) {
            return { buildings: [], users: [] };
        }

        const updatedOverlays = [...overlays];

        const results = await Promise.all(
            manualCircles.map(async (circle) => {
                const center = circle.center;
                const radius = circle.radius;

                const lat = typeof center.lat === "function" ? center.lat() : center.lat;
                const lng = typeof center.lng === "function" ? center.lng() : center.lng;

                const buildingsResponse = await EmpreendimentoService.getEmpreendimentosWithinRadius(lat, lng, radius, this.state);

                const buildings = buildingsResponse.data.empreendimentos;
                const users = await this.getUsers([lat, lng, radius], null);

                const metaData = buildingsResponse.data.meta_data;

                circle.meta_data = metaData;
                circle.meta_data_users = users;

                const overlayIndex = updatedOverlays.findIndex(o => o.id === circle.id);

                if (overlayIndex !== -1) {
                    updatedOverlays[overlayIndex].meta_data = metaData;
                    updatedOverlays[overlayIndex].buildings = buildings;
                    updatedOverlays[overlayIndex].meta_data_users = users;
                    updatedOverlays[overlayIndex].users = users;
                }

                return { buildings, users };
            })
        );

        await new Promise(resolve => {
            this.setState({
                manualCircles: manualCircles,
                overlays: updatedOverlays
            }, resolve);
        });

        const allBuildings = results.flatMap((r) => r.buildings);
        const allUsers = results.flatMap((r) => r.users);

        return { buildings: this.removeDuplicates(allBuildings), users: this.removeUsersDuplicates(allUsers), };
    };


    reloadBuildingsFromPolygons = async () => {
        const { polygons, overlays } = this.state;

        if (!polygons.length) {
            return { buildings: [], users: [] };
        }

        const updatedOverlays = [...overlays];

        const results = await Promise.all(
            polygons.map(async (polygon) => {
                const path = MapaService.getPolygonPath(polygon);
                const closedPath = [...path, path[0]];

                const buildingsResponse = await EmpreendimentoService.getEmpreendimentosWithinPolygon(closedPath, this.state);

                const buildings = buildingsResponse.data.empreendimentos.map((building) => ({ ...building, color: polygon.color, }));

                const users = await this.getUsers(null, [closedPath]);
                const metaData = buildingsResponse.data.meta_data;

                polygon.meta_data = metaData;
                polygon.meta_data_users = users;

                const overlayIndex = updatedOverlays.findIndex(o => o.id === polygon.id);

                if (overlayIndex !== -1) {
                    updatedOverlays[overlayIndex].meta_data = metaData;
                    updatedOverlays[overlayIndex].buildings = buildings;
                    updatedOverlays[overlayIndex].meta_data_users = users;
                    updatedOverlays[overlayIndex].users = users;
                }

                return { buildings, users };
            })
        );

        await new Promise(resolve => {
            this.setState({
                polygons: polygons,
                overlays: updatedOverlays
            }, resolve);
        });

        const allBuildings = results.flatMap((r) => r.buildings);
        const allUsers = results.flatMap((r) => r.users);

        return { buildings: this.removeDuplicates(allBuildings), users: this.removeUsersDuplicates(allUsers), };
    };


    reloadBuildingsInCity = async () => {
        try {
            const buildingsResponse = await EmpreendimentoService.getEmpreendimentoOnCidade(this.state);

            const buildings = buildingsResponse.data.empreendimentos;
            const users = await this.getUsers(null, null);

            const isSingleBuilding = this.state.property_of_interest.length === 1 && buildings.length >= 1;

            const overlay = isSingleBuilding ? {
                id: buildings[0]._id,
                type: "Empreendimento",
                name: buildings[0].nome,
                color: "#4d5a31",
                meta_data: buildingsResponse.data.meta_data,
                meta_data_users: users,
                users,
                buildings,
            } : {
                type: "cidade",
                color: this.getColor(),
                meta_data: buildingsResponse.data.meta_data,
                meta_data_users: users,
                users,
                buildings,
            };

            this.setState(
                (prevState) => ({
                    buildings,
                    users,
                    overlays: isSingleBuilding ? [overlay] : [overlay, ...prevState.overlays],
                    overlay_cidade: !isSingleBuilding,
                    loading: false,
                    showLegenda: true,
                }),
                () => {
                    if (users.length) {
                        this.replaceMarkersUser();
                        this.removeDuplicatesPropertyOfInterest();
                    }

                    if (buildings.length || users.length) {
                        if (isSingleBuilding) {
                            const b = buildings[0];
                            const rawMap = window.googleMap?.context?.__SECRET_MAP_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
                            if (rawMap) {
                                rawMap.panTo({ lat: b.location.coordinates[1], lng: b.location.coordinates[0] });
                                rawMap.setZoom(15);
                            }
                        }
                        this.openPane();
                    } else {
                        toast.warn("Nenhum resultado com os parâmetros fornecidos");
                    }
                }
            );
        } catch (error) {
            console.error("Erro ao carregar empreendimentos por cidade:", error);
            this.setState({ loading: false });
        }
    };


    onCircleComplete = async (circle) => {

        circle = MapaService.onCircleComplete(circle, this.state.manualCircles.length);

        google.maps.event.addListener(circle, 'radius_changed', (event) => { this.onCircleRadiusChanged(circle); });

        google.maps.event.addListener(circle, 'click', (event) => { this.editShapeName(circle); });

        this.setState({
            manualCircles: [circle, ...this.state.manualCircles],
            overlays: [circle, ...this.state.overlays],
            left_side_bar_visible: false
        });

        this.reloadBuildings();
    };

    onCircleRadiusChanged = (circle) => {

        this.setState({ showTooltip: true, radiusChanging: circle.getRadius() });

        setTimeout(() => { this.setState({ showTooltip: false, }) }, 1000)

        this.reloadBuildings();

    }

    centralizarMapaNaForma = (formaId) => {

        const overlay = this.state.overlays.find((overlay) => overlay.id === formaId);

        MapaService.centralizarMapaNaForma(overlay)

    }

    removeOverlay = (id) => {
        const isEmpreendimento = this.state.overlays.find(o => o.id === id)?.type === "Empreendimento";

        let { overlays, manualCircles, polygons } = MapaService.removeOverlay(id, this.state);

        if (isEmpreendimento) {
            this.setState({
                overlays: [...overlays],
                manualCircles: [...manualCircles],
                polygons: [...polygons],
                property_of_interest: [],
                isSlideOpen: overlays.some(o => o.users?.length > 0),
            });
        } else {
            this.setState({
                overlays: [...overlays],
                manualCircles: [...manualCircles],
                polygons: [...polygons],
            });
            this.reloadBuildings();
        }
    }

    toogleOverlayVisibility = (overlay) => {

        MapaService.toogleOverlayVisibility(overlay);

        this.reloadBuildings();
    }

    editShapeName = (shape) => {
        this.setState({
            show_modal_change_shape_attributes: !this.state.show_modal_change_shape_attributes,
            current_shape_editing: shape
        })

        if ($('#results-icon').hasClass('fa-angle-double-right')) { $("#btn-results").click(); }

    }

    updateShape = async (shape) => {

        const { overlays, circles } = MapaService.updateShape(shape, this.state.manualCircles, this.state.overlays);

        this.setState({
            overlays: [...overlays],
            manualCircles: [...circles],
            show_modal_change_shape_attributes: !this.state.show_modal_change_shape_attributes,
            current_shape_editing: null
        });

        if ($('#btn-results').hasClass('fa-angle-double-right')) { $("#btn-results").click(); }
    }


    onRectangleComplete = async (rectangle) => {
        rectangle = MapaService.onRectangleComplete(rectangle, this.state.polygons.length);
        this.setState({
            drawingMode: null,
            polygons: [rectangle, ...this.state.polygons],
            overlays: [rectangle, ...this.state.overlays],
        });
        this.reloadBuildings();
    };
    onPolygonComplete = async (polygon) => {
        polygon = MapaService.onPolygonComplete(polygon, this.state.polygons.length);

        polygon.color = polygon.color || this.getColor();

        google.maps.event.addListener(polygon, 'click', () => { this.editShapeName(polygon); });

        google.maps.event.addListener(polygon.getPath(), 'set_at', async () => { await this.reloadBuildings(); });

        google.maps.event.addListener(polygon.getPath(), 'insert_at', async () => { await this.reloadBuildings(); });

        this.setState({
            polygons: [polygon, ...this.state.polygons],
            overlays: [polygon, ...this.state.overlays],
            left_side_bar_visible: false
        });

        this.reloadBuildings();
    };


    onMarkerClick = (building) => {
        if (!building?.nome) return;

        const current = this.state.property_of_interest;
        const nome = building.nome;
        const newFilter = current.includes(nome)
            ? current.filter((n) => n !== nome)
            : [...current, nome];

        this.setState({ property_of_interest: newFilter }, this.reloadBuildings);

        /* Criação de overlay comentada — agora o clique apenas altera o filtro
        try {
            const params = {
                city: this.state.city.map((c) => c.label),
                incorporators: this.state.incorporators,
                property_of_interest: [building.nome],
                user_type: this.state.user_type,
                age: this.state.age,
                genre: this.state.genre,
                marital_status: this.state.marital_status,
                children: this.state.children,
                minIncome: this.state.minIncome,
                maxIncome: this.state.maxIncome,
            };

            const response = await axios.get("/geo-referenciamento/list", { params });
            const users = response.data;

            const overlay = {
                id: building._id,
                type: "Empreendimento",
                name: building.nome,
                color: "#4d5a31",
                users,
                meta_data_users: users,
                buildings: [building],
            };

            this.setState({ overlays: [overlay], users }, () => {
                this.openPane();
                this.replaceMarkersUser();
                this.removeDuplicatesPropertyOfInterest();
            });
        } catch (error) {
            console.error("Erro ao carregar usuários do empreendimento:", error);
        }
        */
    };

    getProjects = async () => {
        try {
            const { data } = await axios.get(route("getMapaProjetos") + "?geo=1");

            this.setState({
                projetos: [
                    { value: null, label: "Selecione" },
                    ...data.projects,
                ],
            });
        } catch (error) {
            console.error("Erro ao carregar os nomes dos projetos", error);
        }
    };


    handleProjetoChanged = async (e) => {
        if (!e.value) {
            this.setState({ projeto: null, city: [], property_of_interest: [] }, this.reloadBuildings);
            return;
        }

        try {
            const { data } = await axios.get(route('mapa.project.show', e.value));
            const project = data.project;

            const city = project.cidade ? JSON.parse(project.cidade) : [];
            const property_of_interest = project.nome_empreendimento ? JSON.parse(project.nome_empreendimento) : [];

            if (project.lat && project.lng) {
                window.googleMap?.panTo({ lat: parseFloat(project.lat), lng: parseFloat(project.lng) });
            } else if (city.length > 0) {
                const firstCity = city[0];
                const [uf, cityName] = (firstCity.value || '').split('-').map(v => v.trim());
                if (cityName) {
                    const geocoder = new window.google.maps.Geocoder();
                    geocoder.geocode({ address: `${cityName}, ${uf}, Brasil` }, (results, status) => {
                        if (status === 'OK' && results[0]) {
                            window.googleMap.panTo(results[0].geometry.location);
                        }
                    });
                }
            }

            // Remove formas anteriores do mapa
            for (const overlay of this.state.overlays) {
                if (typeof overlay.setMap === 'function') overlay.setMap(null);
            }

            const savedOverlays = project.manualCircles ? JSON.parse(project.manualCircles) : [];
            const restoredCircles = [];
            const restoredPolygons = [];
            const allRestoredOverlays = [];

            const rawMap = window.googleMap?.context?.__SECRET_MAP_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;

            for (const o of savedOverlays) {
                const isCircle = o.type === 'Círculo' || o.type === 'Círculo Manual';
                const isPolygonOrRect = o.type === 'Polígono' || o.type === 'Retângulo';

                if (isCircle && o.center) {
                    const circle = new window.google.maps.Circle({
                        center: o.center,
                        radius: o.radius || 1000,
                        fillColor: o.fillColor || o.color,
                        fillOpacity: 0.3,
                        strokeColor: o.color,
                        strokeWeight: 2,
                        editable: true,
                    });
                    circle.id = o.id || restoredCircles.length;
                    circle.name = o.name;
                    circle.type = o.type;
                    circle.color = o.color;
                    circle.fillColor = o.fillColor || o.color;

                    google.maps.event.addListener(circle, 'radius_changed', () => this.onCircleRadiusChanged(circle));
                    google.maps.event.addListener(circle, 'click', () => this.editShapeName(circle));

                    restoredCircles.push(circle);
                    allRestoredOverlays.push(circle);
                }

                if (isPolygonOrRect && o.path?.length) {
                    const paths = o.path.map(([lat, lng]) => ({ lat, lng }));
                    const polygon = new window.google.maps.Polygon({
                        paths,
                        map: rawMap,
                        fillColor: o.fillColor || o.color,
                        fillOpacity: o.fillOpacity ?? 0.5,
                        strokeColor: o.strokeColor || o.color,
                        strokeWeight: o.strokeWeight ?? 2,
                        editable: true,
                    });
                    polygon.id = o.id || `restored-poly-${restoredPolygons.length}`;
                    polygon.name = o.name;
                    polygon.type = o.type;
                    polygon.color = o.color;
                    polygon.fillColor = o.fillColor || o.color;
                    polygon.strokeColor = o.strokeColor || o.color;
                    polygon.fillOpacity = o.fillOpacity ?? 0.5;
                    polygon.strokeWeight = o.strokeWeight ?? 2;

                    google.maps.event.addListener(polygon, 'click', () => this.editShapeName(polygon));
                    google.maps.event.addListener(polygon.getPath(), 'set_at', async () => { await this.reloadBuildings(); });
                    google.maps.event.addListener(polygon.getPath(), 'insert_at', async () => { await this.reloadBuildings(); });

                    restoredPolygons.push(polygon);
                    allRestoredOverlays.push(polygon);
                }
            }

            this.setState({
                projeto: e.value,
                project_name: project.name,
                city,
                property_of_interest,
                manualCircles: restoredCircles,
                polygons: restoredPolygons,
                overlays: allRestoredOverlays,
            }, this.reloadBuildings);
        } catch (error) {
            console.error('Erro ao carregar projeto:', error);
        }
    };

    setShowMarkers = (showMarkers) => { this.setState({ showMarkers }); };

    setShowBuildings = (showBuildings) => { this.setState({ showBuildings }); };

    setDrawing = (drawing) => {
        this.setState({ isDrawing: drawing, showMarkers: !drawing });
    };

    downloadKml = async () => {

        let payload = {
            ...this.state, polygons: [], manualCircles: [], overlays: []
        }

        payload.circles = this.state.manualCircles

        this.state.polygons.map((polygon) => {
            let polygonPath = MapaService.getPolygonPath(polygon);
            payload.polygons.push(polygonPath);
        })

        payload.circles = await this.getCirclesPlainObjects();
        await KmlService.download(payload);
    }


    getCirclesPlainObjects = async () => {
        return new Promise((resolve) => {
            const circles = this.state.manualCircles.map((circle) => {
                const isNative = typeof circle.getCenter === 'function';
                const centerLatLng = isNative ? circle.getCenter() : null;
                return {
                    latitude: centerLatLng ? centerLatLng.lat() : (circle.center?.lat ?? null),
                    longitude: centerLatLng ? centerLatLng.lng() : (circle.center?.lng ?? null),
                    radius: typeof circle.getRadius === 'function' ? circle.getRadius() : (circle.radius ?? null),
                    name: circle.name,
                    type: circle.type,
                    color: circle.color,
                    fillColor: circle.fillColor,
                    strokeColor: circle.strokeColor,
                    fillOpacity: circle.fillOpacity,
                    strokeWeight: circle.strokeWeight,
                };
            });
            resolve(circles);
        });
    }

    closeModalMapCapture = () => { this.setState({ show_modal_map_screen_capture: false }); }


    initPrint = async () => {
        const wasSlideOpen = this.state.isSlideOpen;

        if (wasSlideOpen) {
            this.setState({ isSlideOpen: false });
        }

        const map = window.googleMap.context.__SECRET_MAP_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;

        map.setOptions({
            disableDefaultUI: true,
            zoomControl: false,
            streetViewControl: false,
            mapTypeControl: false,
            fullscreenControl: false,
            drawingControl: false
        });

        this.setState({
            left_side_bar_visible: false,
            loading: true,
            hide_search_box: true
        });

        await new Promise(resolve => setTimeout(resolve, 1000));

        const mapElement = document.getElementById('map-container');

        if (!mapElement) {
            return;
        }

        const canvas = await html2canvas(mapElement, {
            useCORS: true,
            allowTaint: false,
            scale: 2,
        });

        return { canvas, map, wasSlideOpen };

    }

    finishPrintMap = async (map, wasSlideOpen) => {
        await map.setOptions({
            disableDefaultUI: false,
            zoomControl: true,
            streetViewControl: true,
            mapTypeControl: true,
            fullscreenControl: true,
            drawingControl: true
        });

        this.setState({
            loading: false,
            hide_search_box: false,
            isSlideOpen: wasSlideOpen,
        });
    }

    printMap = async () => {
        try {
            const { canvas, map, wasSlideOpen } = await this.initPrint();

            this.setState({
                mapScreenCaptureData: canvas.toDataURL('image/jpg'),
                show_modal_map_screen_capture: true,
                canvas: canvas
            });
            await this.finishPrintMap(map, wasSlideOpen);

        } catch (error) {
            console.log(error);
        }
    }


    getImageMapaUrl = async () => {

        try {
            const { canvas, map, wasSlideOpen } = await this.initPrint();

            const mapScreenCaptureDataForPDF = canvas.toDataURL('image/jpg');

            this.setState({
                mapScreenCaptureDataForPDF: mapScreenCaptureDataForPDF,
                canvas: canvas
            });

            await this.finishPrintMap(map, wasSlideOpen);

            return mapScreenCaptureDataForPDF;
        } catch (error) {
            console.log(error);
        }
    }

    openModalWork = () => this.setState({ showModalWork: true, errors_projeto: {} });
    handleCloseProjectName = () => this.setState({ showModalWork: false });
    handleNameProjectChanged = (e) => this.setState({ project_name: e.target.value });
    handleShareUsersChanged = (users) => this.setState({ project_share_users: users });

    saveProject = async () => {
        try {
            this.setState({ loadingSaveProject: true });

            const overlaysPayload = this.state.overlays.map(o => {
                const base = { type: o.type, name: o.name, color: o.color, id: o.id };
                const isCircle = o.type === 'Círculo' || o.type === 'Círculo Manual';
                const isPolygonOrRect = o.type === 'Polígono' || o.type === 'Retângulo';

                if (isCircle) {
                    const centerLatLng = typeof o.getCenter === 'function' ? o.getCenter() : null;
                    base.center = centerLatLng
                        ? { lat: centerLatLng.lat(), lng: centerLatLng.lng() }
                        : o.center ?? null;
                    base.radius = typeof o.getRadius === 'function' ? o.getRadius() : (o.radius ?? null);
                    base.fillColor = o.fillColor;
                }

                if (isPolygonOrRect) {
                    try {
                        base.path = MapaService.getPolygonPath(o);
                        base.fillColor = o.fillColor || o.color;
                        base.strokeColor = o.strokeColor || o.color;
                        base.fillOpacity = o.fillOpacity;
                        base.strokeWeight = o.strokeWeight;
                    } catch (e) {
                        console.error('Erro ao serializar forma:', e);
                    }
                }

                return base;
            });

            const center = window.googleMap?.getCenter();
            const payload = {
                project_name: this.state.project_name,
                overlays: overlaysPayload,
                city: this.state.city,
                property_of_interest: this.state.property_of_interest,
                share_users: this.state.project_share_users.map(u => u.id),
                lat: center?.lat() ?? null,
                lng: center?.lng() ?? null,
            };

            if (this.state.projeto) {
                await axios.put(route('updateGeoProject', this.state.projeto), payload);
            } else {
                const { data } = await axios.post(route('storeGeoProject'), payload);
                this.setState({ projeto: data.id });
            }

            this.handleCloseProjectName();
            toast.success('Projeto salvo com sucesso!');
            await this.getProjects();
        } catch (error) {
            if (error.response?.status === 422) {
                this.setState({ errors_projeto: error.response.data.errors || {} });
            } else {
                console.error('Erro ao salvar projeto:', error);
            }
        } finally {
            this.setState({ loadingSaveProject: false });
        }
    };

    deleteProject = async () => {
        if (!this.state.projeto) return;
        try {
            const response = await axios.delete(route('mapa.project.delete', this.state.projeto));
            toast.success(response.data.message);
            this.setState({ projeto: null });
            await this.getProjects();
        } catch (error) {
            console.error('Erro ao excluir projeto:', error);
        }
    };

    render() {
        const { loading, left_side_bar_visible, active_tab, overlays, showMarkers, showBuildings, showLegenda, users, } = this.state;

        return (
            <>
                {loading && <Loader />}

                <MapCapture
                    visible={this.state.show_modal_map_screen_capture}
                    handleClose={this.closeModalMapCapture}
                    imageData={this.state.mapScreenCaptureData}
                    canvas={this.state.canvas}
                />

                <ToastContainer
                    position="top-center"
                    autoClose={3000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                    style={{ width: "60%", color: "#000", zIndex: 9999999 }}
                />
                <ImportarExcelModal
                    show={this.state.showModalImportarExcel}
                    onHide={() => { this.setState({ showModalImportarExcel: false }) }}
                    onLoadingChange={(val) => this.setState({ importLoading: val })}
                    toast={() => toast.warn('Arquivo Importado')}
                    searchBuildings={this.searchBuildings}
                    buscaEmpreendimentossDefaultOptions={this.state.buscaEmpreendimentossDefaultOptions}
                    clearDefaultEmpreendimentos={this.clearDefaultEmpreendimentos}
                    onImportSuccess={(importedProperties, unregisteredProperties) => {
                        if (unregisteredProperties?.length) {
                            toast.warn(`Empreendimento(s) não cadastrado(s), importado(s) mesmo assim: ${unregisteredProperties.join(', ')}`);
                        }
                        this.setState(
                            { property_of_interest: importedProperties?.length ? importedProperties : [] },
                            this.reloadBuildings
                        );
                    }}
                />

                <ModalSalvarProjeto
                    show={this.state.showModalWork}
                    handleClose={this.handleCloseProjectName}
                    project_name={this.state.project_name}
                    handleNameProjectChanged={this.handleNameProjectChanged}
                    share_users={this.state.project_share_users}
                    handleShareUsersChanged={this.handleShareUsersChanged}
                    saveProject={this.saveProject}
                    loading={this.state.loadingSaveProject}
                    errors={this.state.errors_projeto}
                />

                <StoreModal
                    show={this.state.showStoreModal}
                    onHide={() => { this.setState({ showStoreModal: false }) }}
                    reloadBuildings={this.reloadBuildings}
                    toast={() => toast.warn('Informação adicionada.')}
                    searchBuildings={this.searchBuildings}
                />

                <ListModal
                    show={this.state.showListModal}
                    onHide={() => { this.setState({ showListModal: false }) }}
                    selectedOverlay={this.state.selectedOverlay}
                    toast={() => toast.warn('Informação Atualizada.')}
                    reloadBuildings={this.reloadBuildings}


                />

                {
                    this.state.current_shape_editing !== null &&
                    <ShapesAttributesEditor
                        show={this.state.show_modal_change_shape_attributes}
                        shape={this.state.current_shape_editing}
                        onHide={() => { this.setState({ show_modal_change_shape_attributes: false }) }}
                        updateShape={this.updateShape}
                    />
                }

                {
                    !this.state.left_side_bar_visible && <>
                        <div className="map-sidebar-show-button-wrapper">
                            <button
                                title="Mostrar Barra Lateral"
                                onClick={() => { this.setState({ left_side_bar_visible: true }) }}
                                className="btn btn-primary btn-show-map-sidebar">
                                <i className="fas fa-angle-double-right"></i>
                            </button>
                        </div>
                    </>
                }

                <Sidebar
                    visible={left_side_bar_visible}
                    onHide={() => this.setState({ left_side_bar_visible: false })}
                >
                    <Tabs
                        activeKey={active_tab}
                        defaultActiveKey="filtros"
                        onSelect={(active_tab) =>
                            this.setState({ active_tab })
                        }
                    >
                        <Tab eventKey="filtros" title="Filtros">
                            <FormFilters
                                state={this.state}
                                getProjects={this.getProjects}
                                handleProjetoChanged={this.handleProjetoChanged}
                                handleArrayChanged={this.handleArrayChanged}
                                handleChanged={this.handleChanged}
                                handleBedroomsChanged={this.handleBedroomsChanged}
                                handleCityChanged={this.handleCityChanged}
                                searchBuildings={this.searchBuildings}
                                handleSubmit={this.reloadBuildings}
                                resetForm={this.resetForm}
                                clearDefaultEmpreendimentos={
                                    this.clearDefaultEmpreendimentos
                                }
                            />
                        </Tab>

                        <Tab eventKey="ferramentas" title="Ferramentas">
                            <Ferramentas
                                overlays={overlays}
                                showMarkers={showMarkers}
                                setShowMarkers={this.setShowMarkers}
                                showBuildings={showBuildings}
                                setShowBuildings={this.setShowBuildings}
                                centralizarMapaNaForma={this.centralizarMapaNaForma}
                                editShapeName={this.editShapeName}
                                toogleOverlayVisibility={this.toogleOverlayVisibility}
                                removeOverlay={this.removeOverlay}
                                onReloadEmpreendimentos={this.reloadBuildings}
                                downloadKml={this.downloadKml}
                                printMap={this.printMap}
                                importLoading={this.state.importLoading}
                                openImportModal={() => this.setState({ showModalImportarExcel: true, left_side_bar_visible: false })}
                                openModalAddUserGeo={() => this.setState({ showStoreModal: true, left_side_bar_visible: false })}
                                openModalListUsers={(overlay) => this.setState({ showListModal: true, left_side_bar_visible: false, isSlideOpen: false, selectedOverlay: overlay })}
                                openModalWork={this.openModalWork}
                                deleteProject={this.deleteProject}
                                projeto={this.state.projeto}
                            />
                        </Tab>

                        <Tab eventKey="legendas" title="Legenda">
                            <div className="card-body" style={{ height: '100%', overflowY: 'auto', overflowX: 'hidden' }} id="legendas-container">
                                {showLegenda && (
                                    <>
                                        <LegendaUsers />
                                        <Legenda />
                                    </>
                                )}
                            </div>
                        </Tab>
                    </Tabs>
                </Sidebar>

                <div
                    id="content"
                    className="col-12"
                    style={{ position: "relative" }}
                >
                    {users.length > 0 && (
                        <>
                            <button
                                id="btn-results"
                                className="btn btn-sm background-brain"
                                style={{
                                    position: "fixed",
                                    top: "48%",
                                    right: this.state.isSlideOpen ? "37vw" : 0,
                                    zIndex: 15001,
                                    height: 80,
                                    width: 20,
                                    borderTopLeftRadius: 5,
                                    borderBottomLeftRadius: 5,
                                    borderTopRightRadius: 0,
                                    borderBottomRightRadius: 0,
                                    padding: 0,
                                    transform: "translateY(-50%)",
                                }}
                                onClick={() => this.setState({ isSlideOpen: !this.state.isSlideOpen })}
                            >
                                <i
                                    className={`fas ${this.state.isSlideOpen ? "fa-angle-double-right" : "fa-angle-double-left"}`}
                                    aria-hidden="true"
                                />
                            </button>
                            <SlidingPaneEmpreendimento
                                state={this.state}
                                overlays={this.state.overlays}
                                getImageMapaUrl={this.getImageMapaUrl}
                            />
                        </>
                    )}
                    <div id="map-container">

                        <MapWithADrawingManager
                            state={this.state}
                            getColor={this.getColor}
                            setDrawing={this.setDrawing}
                            onMarkerComplete={this.onMarkerComplete}
                            onPolygonComplete={this.onPolygonComplete}
                            onCircleComplete={this.onCircleComplete}
                            onRectangleComplete={this.onRectangleComplete}
                            onMarkerClick={this.onMarkerClick}
                            onCircleRadiusChanged={this.onCircleRadiusChanged}
                            onCircleCenterChanged={this.onCircleCenterChanged}
                            showInfoWindow={this.showInfoWindow}
                            handleShowInfoWindow={this.handleShowInfoWindow}
                            currentPosition={this.state.currentPosition}
                            handleHideInfoWindow={this.handleHideInfoWindow}
                            hide_search_box={this.state.hide_search_box}
                        />
                    </div>
                </div>
            </>
        );
    }
}

export default DefaultMap;

if (document.getElementById("geo_referenciamento_mapa")) {
    ReactDOM.render(
        <DefaultMap />,
        document.getElementById("geo_referenciamento_mapa")
    );
}
